import msalPublicClientApplication from 'core/constants/msal.constants';
import { resetStoreAction, useAppDispatch } from 'core/store';
import { SideNavButton } from '../side-nav-button';

import './side-nav-footer.scss';

export const SideNavFooter = () => {
  const dispatch = useAppDispatch();

  return (
    <ul className="sidenav-footer">
      <SideNavButton
        isActive={false}
        link={{
          label: 'Logout',
          icon: 'sign-out',
          action: async () => {
            await msalPublicClientApplication.logoutPopup({
              postLogoutRedirectUri: '/login',
            });
            dispatch(resetStoreAction());
          },
        }}
      />
    </ul>
  );
};
